module.exports = __webpack_public_path__ + "static/lightning-table-edit-popup-359227789dced9b263d544125fafe3ab.png";